import React, { useContext, useEffect, useState } from 'react';
import * as Yup from 'yup';
import { Row, FormTextArea, FormSelect, FormInput, FormNumber, FormRadio, FormText } from '@digital/ui';
import { Checkbox, Col, Tooltip } from 'antd';
import * as ui from '@digital/ui';
import QuestionarioContextProvider from '../../../../../hooks/useQuestionario';
import { getAbaGeralByNumero, getDemandaContratoSaldoDisponivel } from '@app/api/contrato/geral';
import { GetSasConsicaoPagamentoOptions } from '@app/api/sas/sasProposta';
import { parserCurrency, thousandSeparator } from '@app/helpers/stringHelper';
import { getItemsContrato, ItemContrato } from '@app/api/demanda';
import RadioButton from 'antd/lib/radio/radioButton';
import RadioGroup from 'antd/lib/radio/group';

function DadosDemandaFaturamentoDiretoFields() {
  const {
    statusCodigo,
    setValorPedido,
    valorPedido,
    vigencia,
    setVigencia,
    numeroContrato,
    setNumeroContrato,
    setFornecedorContrato,
    fornecedorContrato,
    setValorTotalContrato,
    valorTotalContrato,
    condicaoPagamento,
    setCondicaoPagamento,
    justificativaContratacao,
    setJustificativaContratacao,
    objetoContratado,
    setObjetoContratado,
    relacionamentoEntidadePublica,
    setRelacionamentoEntidadePublica,
    tipoFaturamento,
    setTipoFaturamento,
    sasCondicaoPagamento,
    haveraMaoDeObraEmPTRConfirmacao,
    setHaveraMaoDeObraEmPTRConfirmacao,
    selectedItemCodigoContrato,
    setSelectedItemCodigoContrato,
    setObjetoContrato,
    objetoContrato,
    selectedOrdemCompra,
    setSelectedOrdemCompra,
    selectedOrdemInvestimento,
    setSelectedOrdemInvestimento,
  } = useContext(QuestionarioContextProvider);

  const [saldoDisponivelContrato, setSaldoDisponivelContrato] = useState<number>();
  const [itensContrato, setItensContrato] = useState<ItemContrato[]>();

  const [selectedItemContrato, setSelectedItemContrato] = useState<ItemContrato>();

  console.log(relacionamentoEntidadePublica);
  useEffect(() => {
    const fetchData = async () => {
      if (numeroContrato && +numeroContrato > 999) {
        const result = await getAbaGeralByNumero(numeroContrato);
        if (result) {
          //3785
          if (!result.isFaturamentoDireto) {
            setObjetoContratado('');
            setObjetoContrato('');
            setValorTotalContrato(0);
            setCondicaoPagamento('');
            setFornecedorContrato('');
            setItensContrato([]);
            setSaldoDisponivelContrato(0);
            setValorPedido(0);
            ui.notification.error('O Contrato deve ser do tipo Faturamento Direto');
            return;
          }

          const resultSaldoDisponivel = await getDemandaContratoSaldoDisponivel(numeroContrato);
          if (resultSaldoDisponivel) {
            setSaldoDisponivelContrato(resultSaldoDisponivel.saldoDisponivel);
          }

          const itemsContrato = await getItemsContrato(numeroContrato);
          if (itemsContrato) {
            setItensContrato(itemsContrato.itens);
          }

          setObjetoContrato(result.dadosGerais_Objeto);
          setValorTotalContrato(result.dadoConsolidado_ValorAtual);
          //setCondicaoPagamento(result.dadosGerais_CondicaoPagamento);
          //setCondicaoPagamento('');
          setFornecedorContrato(result.fornecedor_Nome);
          return;
        }
      }

      setItensContrato([]);
      setObjetoContratado('');
      setSaldoDisponivelContrato(0);
      setValorPedido(0);
      setValorTotalContrato(0);
      setCondicaoPagamento('');
      setFornecedorContrato('');
    };

    fetchData();
  }, [numeroContrato]);

  const fetchOptions = async () => {
    if (!itensContrato) return [];

    const unicosPorCodigo = Array.from(new Map(itensContrato.map(item => [item.codigoItem, item])).values());

    return unicosPorCodigo.map(item => ({
      value: item.codigoItem,
      text: `${item.descricaoItem} (${item.codigoItem})`,
    }));
  };

  useEffect(() => {
    if (selectedItemCodigoContrato && itensContrato && itensContrato.length > 0) {
      const item = itensContrato.find(i => i.codigoItem === selectedItemCodigoContrato);
      if (item) {
        setSelectedItemContrato(item);
      }
    }
  }, [selectedItemCodigoContrato, itensContrato]);

  return (
    <div className="no-padding">
      {
        <>
          <Row>
            <FormInput
              required
              id="mrn-input-numeroContrato"
              label="Número do Contrato"
              name="numeroContrato"
              span={4}
              type="number"
              value={numeroContrato}
              onChange={e => setNumeroContrato(e.target.value)}
            />

            <FormSelect
              id="mrn-select-tipoFaturamento"
              onSelect={e => setTipoFaturamento(Number(e))}
              options={[
                { text: 'Material', value: 1 },
                { text: 'Serviço', value: 2 },
              ]}
              label="Tipo de faturamento"
              name="tipoFaturamento"
              span={4}
              required
              disabled={valorTotalContrato && valorTotalContrato > 0 ? false : true}
            />

            <FormInput
              required
              id="mrn-input-vigencia"
              label="Vigência (Em meses)"
              name="vigencia"
              type="number"
              span={4}
              value={vigencia}
              onChange={e => setVigencia(e.target.value ? +e.target.value : 0)}
              disabled={valorTotalContrato && valorTotalContrato > 0 ? false : true}
            />

            <FormNumber
              max={saldoDisponivelContrato}
              formatter={e => thousandSeparator(e)}
              parser={e => parserCurrency(e)}
              onChange={e => {
                if (String(e).length === 0) {
                  return setValorPedido(0);
                }
                if (e) {
                  if (String(e).split('.')[1] && String(e).split('.')[1].length === 0) {
                    return setValorPedido(e);
                  }
                  return setValorPedido(e);
                }
              }}
              name="valorPedido"
              label="Valor do Pedido"
              step={0.01}
              span={4}
              disabled={valorTotalContrato && valorTotalContrato > 0 ? false : true}
              required={valorPedido && valorPedido > 0 ? false : true}
              value={Number(valorPedido)}
            />

            <FormSelect
              label="Condição de Pagamento"
              name="sasCondicaoPagamentoId"
              getOptions={GetSasConsicaoPagamentoOptions}
              onChange={e => {
                const condicao = sasCondicaoPagamento.find(cond => cond.id === e);
                if (condicao && condicao.descricao) {
                  setCondicaoPagamento(condicao.descricao);
                }
              }}
              defaultValue={condicaoPagamento}
              value={condicaoPagamento}
              span={4}
              disabled={valorTotalContrato && valorTotalContrato > 0 ? false : true}
              required={condicaoPagamento && condicaoPagamento.length > 0 ? false : true}
            />

            <FormSelect
              label="Itens do Contrato"
              name="itemCodigoContrato"
              getOptions={fetchOptions}
              onChange={codigoSelecionado => {
                const item = itensContrato && itensContrato.find(i => i.codigoItem === codigoSelecionado);
                if (item) {
                  setSelectedItemContrato(item);
                  setSelectedItemCodigoContrato(item.codigoItem);
                  setSelectedOrdemCompra(item.ordemCompra);
                  setSelectedOrdemInvestimento(item.ordemInvestimento);
                }
              }}
              value={(selectedItemContrato && selectedItemContrato.codigoItem) || ''}
              defaultValue={(selectedItemContrato && selectedItemContrato.codigoItem) || ''}
              span={4}
              required={!selectedItemContrato}
              disabled={valorTotalContrato && valorTotalContrato > 0 ? false : true}
            />

            <FormNumber
              formatter={e => thousandSeparator(e)}
              parser={e => parserCurrency(e)}
              name="saldoDisponivelContrato"
              label="Saldo Disponível no Contrato"
              step={0.01}
              span={4}
              value={saldoDisponivelContrato}
              disabled
            />

            <FormNumber
              formatter={e => thousandSeparator(e)}
              parser={e => parserCurrency(e)}
              name="valorTotalContrato"
              label="Valor Total do Contrato"
              step={0.01}
              span={4}
              value={Number(valorTotalContrato)}
              disabled
            />

            <FormInput
              id="mrn-input-numeroContrato"
              label="Fornecedor Associado ao Contrato"
              name="fornecedoContrato"
              span={4}
              disabled={true}
              type="text"
              value={fornecedorContrato}
              onChange={e => setFornecedorContrato(e.target.value)}
            />
          </Row>

          <Row>
            <FormTextArea
              id="mrn-textarea-objetoASerContratado"
              name="objeto"
              label="Objeto do Contrato"
              span={12}
              rows={2}
              maxLength={4000}
              value={objetoContrato}
              disabled
            />
          </Row>

          <Row>
            <FormTextArea
              id="mrn-textarea-objetoASerContratado"
              name="objeto"
              label="Objeto a Ser Contratado"
              span={12}
              rows={3}
              maxLength={4000}
              value={objetoContratado}
              required={objetoContratado && objetoContratado.length > 0 ? false : true}
              onChange={e => setObjetoContratado(e.target.value)}
              disabled={valorTotalContrato && valorTotalContrato > 0 ? false : true}
            />
          </Row>
          <Row>
            <FormTextArea
              id="mrn-textarea-justificativaRequisicaoCompra"
              label="Justificativa da Contratação"
              name="justificativaRequisicaoCompra"
              span={12}
              rows={3}
              required={justificativaContratacao && justificativaContratacao.length > 0 ? false : true}
              value={justificativaContratacao}
              onChange={e => setJustificativaContratacao(e.target.value)}
              disabled={valorTotalContrato && valorTotalContrato > 0 ? false : true}
            />
          </Row>

          <Row>
            <Col span={6}>
              <Tooltip title="Toda e qualquer tipo de subcontratação de serviços que envolvam representantes, entidades ou agentes públicos, ONGs e fundações sem fins lucrativos">
                <FormRadio
                  label="Haverá Mão de Obra em PTR"
                  name="haveraMaoDeObraEmPTRConfirmacao"
                  value={
                    haveraMaoDeObraEmPTRConfirmacao === true
                      ? 'true'
                      : haveraMaoDeObraEmPTRConfirmacao === false
                      ? 'false'
                      : undefined
                  }
                  options={[
                    { text: 'Sim', value: 'true' },
                    { text: 'Não', value: 'false' },
                  ]}
                  onChange={e => {
                    const val = e.target.value;
                    if (val === 'true') setHaveraMaoDeObraEmPTRConfirmacao(true);
                    else if (val === 'false') setHaveraMaoDeObraEmPTRConfirmacao(false);
                    else setHaveraMaoDeObraEmPTRConfirmacao(undefined);
                  }}
                  required={haveraMaoDeObraEmPTRConfirmacao !== undefined ? false : true}
                  disabled={!(valorTotalContrato && valorTotalContrato > 0)}
                />
              </Tooltip>
            </Col>

            <Col span={6}>
              <Tooltip title="Toda e qualquer tipo de subcontratação de serviços que envolvam representantes, entidades ou agentes públicos, ONGs e fundações sem fins lucrativos">
                <FormRadio
                  label="Rel. Entidade Pública"
                  name="relacionamentoEntidadePublica"
                  value={
                    relacionamentoEntidadePublica === true
                      ? 'true'
                      : relacionamentoEntidadePublica === false
                      ? 'false'
                      : undefined
                  }
                  options={[
                    { text: 'Sim', value: 'true' },
                    { text: 'Não', value: 'false' },
                  ]}
                  onChange={e => {
                    const val = e.target.value;
                    if (val === 'true') setRelacionamentoEntidadePublica(true);
                    else if (val === 'false') setRelacionamentoEntidadePublica(false);
                    else setRelacionamentoEntidadePublica(undefined);
                  }}
                  required={relacionamentoEntidadePublica !== undefined ? false : true}
                  disabled={!(valorTotalContrato && valorTotalContrato > 0)}
                />
              </Tooltip>
            </Col>
          </Row>
        </>
      }
    </div>
  );
}

export default DadosDemandaFaturamentoDiretoFields;
